import { APIException } from '~/plugins/axios/lib/exception'

export class OrderAPIException extends APIException {
  constructor (...args: ConstructorParameters<typeof APIException>) {
    super(...args)

    this.name = 'OrderAPIException'
  }
}
